__webpack_require__.p = "https://trading.iuxbeta.com/";